import React from 'react';
import { Table, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import ChartWrapper from './ChartWrapper';

const TopProductsTable = ({
    data,
    columns,
    title,
    showTopCount = 5,
    loading,
    link
}) => {
    const displayData = data ? data.slice(0, showTopCount) : [];

    const tableContent = () => {
        if (loading) {
            return (
                <div className="flex justify-center items-center h-64">
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                </div>
            );
        }

        return (
            <Table
                dataSource={displayData}
                columns={columns}
                pagination={false}
                size="small"
                scroll={{ x: true }}
                rowKey={(record, index) => index}
            />
        );
    };

    return (
        <ChartWrapper
            title={title}
            link={link}
        >
            {tableContent()}
        </ChartWrapper>
    );
};

export default TopProductsTable;